import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
const Excel = require("exceljs");
import { saveAs } from "file-saver";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonService } from "src/app/services/common.service";
import Math from "exact-math";
import { StorageService } from "../../services/storage.service";
import { UpdateRoleModalComponent } from "../update-role-modal/update-role-modal.component";
import { DownloadReportComponent } from "../../pages/download-report/download-report.component";
import { PROFESSOR_REPORT_HEADERS_KEYS } from "../../shared/constants/professor-report.constants";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";

function noSpaceValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value && /\s/.test(control.value)) {
    return { noSpaces: true };
  }
  return null;
}
@Component({
  selector: "app-professor-management",
  templateUrl: "./professor-management.component.html",
  styleUrls: ["./professor-management.component.css"],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ProfessorManagementComponent implements OnInit {
   @ViewChild(DownloadReportComponent) child:DownloadReportComponent;
    expandedElement = false;
    studentReportHeadersKeys =  PROFESSOR_REPORT_HEADERS_KEYS;
  private ls = new SecureLS({ encodingType: "aes" });
  page_download: any;
  page_size_download: any;
  batch_id: any;
  course_id: any;
  ProfessorForm: FormGroup;
  bulk_form: FormGroup;
  addRoleForm: FormGroup;
  page: number = 1;
  page_size: number = 10;
  submitted = false;
  active = 1;
  swal: any;
  total_count = 0;
  procreate: any;
  professorList: any[];
  getprofessor: any;
  editprofessor: any;
  is_active = false;
  deleteprofessor: any;
  editstatus = false;
  proupdate: any;
  prostatusupdate: any;
  editid: any;
  department: any;
  dept = [];
  downloadstatus: any;
  download_video: any;
  hod: any;
  isactiveswitch: any;
  isdownswitch: any;
  ishodswitch: any;
  editbut: boolean;
  selectedFiles: any;
  bulkcreate: any;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  first_name: any;
  last_name: any;
  email_address: any;
  mobile_number: any;
  username: any;
  department_id: any;
  total: number;
  p: number;
  pagedItems: any[];
  stucreatepost: any;
  searchForm: FormGroup;
  chiparray: any = [];
  filtervalues: boolean;
  value: string;
  entryFields: boolean = false;
  createNew: boolean = true;
  write_access: boolean = false;
  isHod: any;
  backendValidationErrors: any;
  professorList1: any[];
  getprofessor1: any;
  

  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    private fileupload: CommonService,
    private fb: FormBuilder,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2
  ) {}

  async ngOnInit() {
    this.entryFields = false;
    this.createNew = true;
    this.isHod =
      parseInt(this.ls.get("hod")) === 1
        ? this.ls.get("hod")
        : this.ls.get("impersonate_hod") === true
        ? 1
        : 0;
    this.addRoleForm = this.fb.group({
      id: [""],
      role: ["", Validators.required],
    });
    this.searchForm = this.fb.group({
      id: [""],
      fname: [""],
      lname: [""],
      uname: [""],
      email: [""],
      mobile: [""],
      depname: [""],
    });
    this.ProfessorForm = this.fb.group({
      id: [""],
      first_name: [
        "",
        [Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/)],
      ],
      last_name: [
        "",
        [Validators.required, Validators.pattern(/^[a-zA-Z\s]*$/)],
      ],
      username: ["", [Validators.required, noSpaceValidator]],
      mobile_number: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      email_address: ["", [Validators.required]],
      department_id: ["", [Validators.required]],
      is_active: [""],
      download_video: [""],
      hod: [""],
    });
    this.bulk_form = this.fb.group({
      bulk_file: [""],
    });
    this.page = 1;
    if (this.storageService.getRole() == 4 && this.isHod == 1) {
      this.write_access = true;
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.searchForm.controls["depname"].disable();
      this.department_id = this.storageService.getDepartment();
    }

    this.ProfessorForm.valueChanges.subscribe((data) => {
      this.backendValidationErrors = null;
    });
    await this.getDepartment();
    await this.getProfessor();
    await this.getPage(this.page, true);
    if (this.storageService.getRole() == 4 && this.isHod == 1) {
      this.Filter(
        this.first_name,
        this.last_name,
        this.email_address,
        this.mobile_number,
        this.username,
        this.department_id
      );
    }
  }

  openAddRole(professor) {
    if (this.ls.get("token")) {
      const modalRef = this.modalService.open(UpdateRoleModalComponent, {
        scrollable: true,
      });
      modalRef.componentInstance.userDetails = professor;
      modalRef.componentInstance.roleList = [
        { id: 3, name: "Sub Admin" },
        { id: 5, name: "Learner" },
      ];
      modalRef.componentInstance.notifyParent.subscribe((e) => {
        if(e == 'success') {
          this.getProfessor();
        }
      });
    }
  }

  getUserRoleDetails(user) {
    return user?.userByRole.map((e)=> e.role).join(', ');
  }

  onActiveTab(active) {
    if (active !== 1) {
      this.bulk_form.controls["bulk_file"].patchValue("");
    }
  }
  expandRow(eList) {
    this.professorList.forEach((list) => {
      if (eList.id === list.id) {
        list["isExpand"] = true;
      } else {
        list["isExpand"] = false;
      }
    });
  }
  collapseRow(eList) {
    this.professorList.forEach((list) => {
      list["isExpand"] = false;
    });
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.ProfessorForm.reset();
    this.submitted = false;
  }
  openEdit() {
    this.getDepartment();
    this.entryFields = true;
    this.createNew = false;
    this.editbut = false;
    this.ProfessorForm.reset();
    this.submitted = false;
  }

  cancelFields() {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.ProfessorForm.reset();
    this.createNew = true;
    this.entryFields = false;
  }
  async getPage(page: number, disableCall: boolean) {
    this.page = page;
    if(!disableCall){
      await this.getProfessor();
    }
    const res = await this.serverCall(this.professorList, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }
  async setlocalstorage(
    id,
    role_id,
    email_address,
    department_id,
    batch_id,
    course_id,
    first_name,
    last_name,
    hod
  ) {
    this.spinner.show();
    let keys: string[] = [
      "vendor_id",
      "createdBy",
      "vendor_logo",
      "vendor_sub_logo",
      "write_access",
    ];
    keys.forEach((el) => {
      this.ls.set(`impersonate_${el}`, this.ls.get(el));
    });

    this.ls.set("impersonate_department_id", department_id);
    this.ls.set("impersonate_batch_id", batch_id);
    this.ls.set("impersonate_course_id", course_id);
    this.ls.set("impersonate_user_id", id);
    this.ls.set("impersonate_email_address", email_address);
    this.ls.set("impersonate_role", role_id);
    this.ls.set("impersonate_first_name", first_name);
    this.ls.set("impersonate_last_name", last_name);
    this.ls.set("impersonate_hod", hod);
    let inputData = {
      user_id: this.ls.get("user_id"),
      impersonate_user_id: this.ls.get("impersonate_user_id"),
      impersonate_role_id: this.ls.get("impersonate_role"),
    };

    this.stucreatepost = await this.globalService.create(
      "user/generate/impersonate/token",
      inputData
    );
    this.ls.set("impersonate_token", this.stucreatepost.token);
    this.ls.set("impersonate_user_id", this.stucreatepost.user_id);
    window.open(location.origin + "/dashboard?loginType=impersonate", "_blank");
    this.spinner.hide();
  }
  async serverCall(sample: any[], page: number) {
    const perPage = 10;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  get forms1() {
    return this.searchForm.controls;
  }
  get forms() {
    return this.ProfessorForm.controls;
  }
  async getDepartment() {
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: "4",
    };
    this.department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );

    this.dept = this.department["content"];
    if (this.storageService.getRole() == 4 && this.isHod == 1) {
      this.write_access = true;
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.searchForm.controls["depname"].disable();
      this.department_id = this.storageService.getDepartment();
    }
  }
  switch(e) {
    this.isactiveswitch = e;
  }
  switchdown(e) {
    this.isdownswitch = e;
  }
  switchhod(e) {
    this.ishodswitch = e;
  }
  async createProfessor(form: FormGroup) {
    this.submitted = true;
    if (this.ProfessorForm.invalid) {
      return;
    }
    this.spinner.show();
    const inputData = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      first_name: form.value.first_name,
      last_name: form.value.last_name,
      username: form.value.username,
      mobile_number: form.value.mobile_number,
      email_address: form.value.email_address,
      department_id: form.value.department_id,
      hod: form.value.hod == 1 ? "1" : "0",
      is_active: this.isactiveswitch
        ? this.isactiveswitch == true
          ? "1"
          : "0"
        : "0",
      download_video: this.isdownswitch
        ? this.isdownswitch == true
          ? "1"
          : "0"
        : "0",
      role_id: "4",
    };

    this.procreate = await this.globalService.create(
      "commonUser/create",
      inputData
    );

    if (this.procreate["status"] === 200) {
      Swal.fire("Success!", this.procreate["message"], "success");
      this.spinner.show();
      this.pageshow = true;
      this.getProfessor();
      this.reset();
      this.entryFields = false;
      this.createNew = true;
      this.renderer.removeClass(document.body, "modal-open");
      this.backendValidationErrors = null;
    } else if (this.procreate["status"] === 422) {
      this.backendValidationErrors = this.procreate?.error["content"];
    } else {
      this.cancelFields();
      this.spinner.hide();
    }
    this.spinner.hide();
  }
  async onClickReportDownload(event) {
    let reportname= "Professor Report List"
    if(event.pageno){
      this.page_download = event.pageno;
      this.page_size_download = event.pagesize;
      await this.getExcelReport(event.download);
    }
    else{
      this.page_download = 1;
      this.page_size_download = 1000;
      await this.getExcelReport(true);
    } 
    await this.child.processReportDownload(this.professorList1,reportname);
  }

  async getProfessor() {
    this.spinner.show();
    if (this.page === 1) {
      this.professorList = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      role_id: 4,
      first_name: this.first_name,
      last_name: this.last_name,
      email_address: this.email_address,
      mobile_number: this.mobile_number,
      username: this.username,
      department_id: this.department_id,
      page_size: this.page_size,
    };

    this.getprofessor = await this.globalService.get("commonUser/list", filter);
    if (this.getprofessor["status"] === 200) {
      this.total_count = this.getprofessor["content"].count;
      this.professorList = this.getprofessor["content"]["rows"];
      this.professorList = this.professorList.map((list) => {
        list["isExpand"] = false;
        return list;
      });
      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(this.total_count / this.page_size);
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
    }
    else{
      this.htmlpageshow = false;
    }
    (error) => {
      this.professorList = [];
      this.spinner.hide();
    };

    this.spinner.hide();
  }

  async getExcelReport(isRoprtDownload?) {
    this.spinner.show();
    this.professorList1 = [];  

    let filter1 = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      role_id: 4,
      first_name: this.first_name,
      last_name: this.last_name,
      email_address: this.email_address,
      mobile_number: this.mobile_number,
      username: this.username,
      department_id: this.department_id,
      page_size:  (isRoprtDownload) ? this.page_size_download : 1000,
    };

    this.getprofessor1 = await this.globalService.get("commonUser/list", filter1);
    
    if (this.getprofessor1["status"] === 200) {
      this.total_count = this.getprofessor1["content"].count;    
      this.professorList1 = this.getprofessor1["content"]["rows"];
    }
    (error) => {
      this.spinner.hide();
    };
    this.spinner.hide();
  }
  openScrollableContent(longContent) {
    this.modalService.open(longContent, { scrollable: true });
    this.getDepartment();
  }
  Filter(
    first_name,
    last_name,
    email_address,
    mobile_number,
    username,
    department_id
  ) {
    this.filtervalues = true;
    this.chiparray = [];

    if (this.first_name != undefined && this.first_name != "") {
      this.chiparray.push("Fname :" + " " + this.first_name);
    }

    if (this.last_name != undefined && this.last_name != "") {
      this.chiparray.push("Lname :" + " " + this.last_name);
    }
    if (this.username != undefined && this.username != "") {
      this.chiparray.push("Uname :" + " " + this.username);
    }
    if (this.email_address != undefined && this.email_address != "") {
      this.chiparray.push("Email :" + " " + this.email_address);
    }
    if (this.mobile_number != undefined && this.mobile_number != "") {
      this.chiparray.push("Mobile :" + " " + this.mobile_number);
    }
    if (this.department_id != undefined && this.department_id != "") {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0]?.name);
    }
    this.first_name = first_name;
    this.last_name = last_name;
    this.email_address = email_address;
    this.mobile_number = mobile_number;
    this.username = username;
    this.department_id = department_id;
    this.pageshow = true;
    this.page = 1;
    this.getProfessor();
  }
  res() {
    this.filtervalues = false;
    this.first_name = null;
    this.last_name = null;
    this.email_address = null;
    this.mobile_number = null;
    this.username = null;
    this.backendValidationErrors = null;
    if (this.storageService.getRole() != 4 && this.isHod != 1) {
      this.department_id = null;
    }
    this.searchForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getProfessor();
    if (this.storageService.getRole() == 4 && this.isHod == 1) {
      this.filtervalues = true;
      this.department_id = this.department_id;
      this.getDepartment();
    }
  }
  async editProfessor(id) {
    this.getDepartment();
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      this.editbut = true;
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.active = 2;
        this.openField();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          role_id: "4",
          id: id,
        };

        this.editprofessor = await this.globalService.get(
          "commonUser/get",
          filter
        );
        let comp_details = this.editprofessor["content"];

        if (this.editprofessor["status"] === 200) {
          this.ProfessorForm.controls["id"].setValue(comp_details.id);
          this.ProfessorForm.controls["first_name"].setValue(
            comp_details.first_name
          );
          this.ProfessorForm.controls["last_name"].setValue(
            comp_details.last_name
          );
          this.ProfessorForm.controls["username"].setValue(
            comp_details.username
          );
          this.ProfessorForm.controls["email_address"].setValue(
            comp_details.email_address
          );
          this.ProfessorForm.controls["mobile_number"].setValue(
            comp_details.mobile_number
          );
          this.ProfessorForm.controls["department_id"].setValue(
            comp_details.department_id
          );

          this.ProfessorForm.controls["hod"].setValue(
            comp_details.hod ? "1" : "0"
          );

          this.editid = comp_details.id;
          this.editstatus = comp_details.is_active;
          this.downloadstatus = comp_details.download_video;
        }
        this.spinner.hide();
      } else {
        this.cancelFields();
      }
    });
  }

  reset() {
    this.submitted = false;
    this.ProfessorForm.reset();
    this.editstatus = false;
    this.isactiveswitch = false;
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;

    this.getProfessor();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getProfessor();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getProfessor();
  }
  ProfessorStatusUpdate(value: boolean, id) {
    this.spinner.show();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to Change Status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let status;
        if (value == false) {
          status = "0";
        } else if (value == true) {
          status = 1;
        }
        const inputData = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id ? id : this.editid,
          is_active: status,
        };

        this.prostatusupdate = await this.globalService.update(
          "commonUser/update/status",
          inputData
        );
        if (this.prostatusupdate["status"] === 200) {
          Swal.fire("Success!", this.prostatusupdate["message"], "success");
          this.pageshow = true;
          this.getProfessor();
        }
        if (this.prostatusupdate["status"] != 200) {
          this.pageshow = true;
          this.getProfessor();
        }
        this.is_active = status;
      } else {
        this.pageshow = true;
        this.getProfessor();
      }
    });
    this.spinner.hide();
  }

  async updateProfessor(form: FormGroup) {
    this.submitted = true;

    if (this.ProfessorForm.invalid) {
      return;
    }
    this.spinner.show();
    const inputData = {
      id: form.value.id,
      vendor_id: this.ls.get("vendor_id"),
      is_active: this.is_active
        ? this.is_active
        : this.editstatus === true
        ? "1"
        : "0",
      user_id: this.ls.get("createdBy"),
      first_name: form.value.first_name,
      last_name: form.value.last_name,
      username: form.value.username,
      mobile_number: form.value.mobile_number,
      email_address: form.value.email_address,
      department_id: form.value.department_id,
      download_video: this.download_video
        ? this.download_video
        : this.downloadstatus === true
        ? "1"
        : "0",
      hod: form.value.hod == 1 ? "1" : "0",
      role_id: "4",
    };
    this.proupdate = await this.globalService.update(
      "commonUser/update",
      inputData
    );

    if (this.proupdate["status"] === 200) {
      Swal.fire("Success!", this.proupdate["message"], "success");
      this.pageshow = true;
      this.getProfessor();
      this.editbut = false;
      this.reset();
      this.entryFields = false;
      this.createNew = true;
      this.backendValidationErrors = null;
      this.renderer.removeClass(document.body, "modal-open");
    } else if (this.proupdate["status"] === 422) {
      this.backendValidationErrors = this.proupdate?.error["content"];
    } else {
      this.backendValidationErrors = null;
      this.cancelFields();
    }
    this.spinner.hide();
  }

  async deleteProfessor(id) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: id,
          role_id: "4",
        };
        this.deleteprofessor = await this.globalService.delete(
          "commonUser/delete",
          filter
        );
        if (this.deleteprofessor["status"] === 200) {
          this.professorList = [];
          Swal.fire("Success!", this.deleteprofessor["message"], "success");
          this.pageshow = true;
          this.getProfessor();
          this.spinner.hide();
        }
      }
      this.spinner.hide();
    });
    this.spinner.hide();
  }
  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  async BulkUpload(form: FormGroup) {
    this.spinner.show();

    if (
      form.value.bulk_file === null ||
      form.value.bulk_file === undefined ||
      form.value.bulk_file === ""
    ) {
      Swal.fire("", "Please upload the file", "error");
      this.spinner.hide();
      return;
    }

    const file = this.selectedFiles.item(0);
    if (
      file.type !== "application/vnd.ms-excel" &&
      file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      file.type !== "application/vnd.oasis.opendocument.spreadsheet"
    ) {
      this.spinner.hide();
      Swal.fire("Error!", "Only Excel files are allowed", "error");
      return;
    }

    if (file.size > 2097152) {
      Swal.fire("Warning!", "File Size Must be under 2 MB", "warning");
      this.spinner.hide();
      return;
    } else if (
      file.type == "application/vnd.ms-excel" ||
      file.type ==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      file.type == "application/vnd.oasis.opendocument.spreadsheet"
    ) {
      let formdata = new FormData();
      formdata.append("file", file);
      formdata.append("user_id", this.ls.get("createdBy"));
      formdata.append("vendor_id", this.ls.get("vendor_id"));
      formdata.append("upload_role_id", "4");
      formdata.append("role_id", String(this.storageService.getRole()));
      formdata.append("requester_type", "web");

      this.bulkcreate = await this.globalService.create(
        "commonUser/bulk/create",
        formdata
      );

      if (this.bulkcreate["status"] === 200) {
        let bulk = this.bulkcreate["content"];
        const expectedHeaders = [
          "username",
          "first_name",
          "last_name",
          "email_address",
          "mobile_number",
          "department",
        ];

        const missingDataRows = bulk.filter((row) => {
          return expectedHeaders.some((header) => !row[header]);
        });
        if (missingDataRows.length > 0) {
          Swal.fire(
            "Warning!",
            "Some rows are missing data for required headers. Please check the file.",
            "warning"
          );
        } else {
          let dataExport = [];
          for (let i = 0; i < bulk.length; i++) {
            dataExport.push({
              Sno: i + 1,
              username: bulk[i].username,
              first_name: bulk[i].first_name,
              last_name: bulk[i].last_name,
              email_address: bulk[i].email_address,
              mobile_number: bulk[i].mobile_number,
              hod: bulk[i].hod,
              department: bulk[i].department,
              message: bulk[i].message,
            });
          }

          var a = await this.fileupload.exportExcel(
            dataExport,
            "Professor List"
          );
          Swal.fire("Success!", this.bulkcreate["message"], "success");
          this.pageshow = true;
          this.getProfessor();
          this.bulk_form.reset();
        }
      }
      this.spinner.hide();
    }

    this.spinner.hide();
    this.cancelFields();
  }

  resetbulk() {
    this.bulk_form.reset();
  }
  async downloadSampleTemplate() {
    await this.getDepartment();
    let temp = [];
    let temp1 = [0, 1];
    this.dept.forEach((e) => {
      temp.push(e.name);
    });

    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    worksheet.getCell("A1").value = "Sno";
    worksheet.getCell("B1").value = "username";
    worksheet.getCell("C1").value = "first_name";
    worksheet.getCell("D1").value = "last_name";
    worksheet.getCell("E1").value = "email_address";
    worksheet.getCell("F1").value = "mobile_number";
    worksheet.getCell("G1").value = "department";
    worksheet.getCell("H1").value = "hod";

    worksheet.getCell("A2").value = "1";
    worksheet.getCell("B2").value = "v2e10333";
    worksheet.getCell("C2").value = "Sara";
    worksheet.getCell("D2").value = "M";
    worksheet.getCell("E2").value = "raj@gmail.com";
    worksheet.getCell("F2").value = "8907654312";

    const dobCol = worksheet.getColumn(9);
    dobCol.hidden = true;
    const dobCol1 = worksheet.getColumn(10);
    dobCol1.hidden = true;
    const dobCol2 = worksheet.getColumn(11);
    dobCol2.hidden = true;
    for (let i = 2; i < 2500; i++) {
      worksheet.getCell(`G${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        showInputMessage: false,
        formulae: ["$J$1:$J$1048576"],
      };
    }
    for (let i = 2; i < 2500; i++) {
      worksheet.getCell(`H${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        showInputMessage: false,
        formulae: ["$K$1:$K$1048576"],
      };
    }
    worksheet.getColumn(1).width = 20;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 20;
    worksheet.getColumn(6).width = 20;
    worksheet.getColumn(7).width = 20;
    worksheet.getColumn(8).width = 20;
    worksheet.getColumn(9).width = 20;
    worksheet.getColumn(10).width = 20;
    worksheet.getColumn(11).width = 20;
    worksheet.getColumn(12).width = 20;
    worksheet.getColumn(13).width = 20;
    for (let index = 0; index < temp.length; index++) {
      worksheet.getCell(`J${index + 1}`).value = temp[index];
      const element = temp[index];
    }
    for (let index = 0; index < temp1.length; index++) {
      worksheet.getCell(`K${index + 1}`).value = temp1[index];
      const element = temp1[index];
    }

    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "Professor Sample List" + ".xlsx");
    });
  }

  formAddReset() {
    this.ProfessorForm.reset();
    this.editbut = false;
  }
  formUpdateReset() {
    this.ProfessorForm.controls["id"].setValue(
      this.editprofessor["content"].id
    );
    this.ProfessorForm.controls["first_name"].setValue(
      this.editprofessor["content"].first_name
    );
    this.ProfessorForm.controls["last_name"].setValue(
      this.editprofessor["content"].last_name
    );
    this.ProfessorForm.controls["username"].setValue(
      this.editprofessor["content"].username
    );
    this.ProfessorForm.controls["email_address"].setValue(
      this.editprofessor["content"].email_address
    );
    this.ProfessorForm.controls["mobile_number"].setValue(
      this.editprofessor["content"].mobile_number
    );
    this.ProfessorForm.controls["department_id"].setValue(
      this.editprofessor["content"].department_id
    );

    this.ProfessorForm.controls["hod"].setValue(
      this.editprofessor["content"].hod ? "1" : "0"
    );
    this.ProfessorForm.reset();
    this.ProfessorForm.get("id").setValue(this.editprofessor["content"].id);
  }

  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getProfessor();
  }
}
